import { InfoOutlined } from "@mui/icons-material";
import { Alert, Box, Card, Container, Typography } from "@mui/material";
import LoadingButton from "@mui/lab/LoadingButton";
import { useFormContext } from "react-hook-form";
import authHelperImage from "/images/auth-helper-image.png";
import authHelperImage2 from "/images/auth-helper-image-2.png";
import { useCustomMutation } from "@refinedev/core";
import { AmazonSelectExample } from "../components/amazon-select-example/AmazonSelectExample";
import { useTranslation } from "../../../../hooks/useTranslation";

type AuthorizationResponse = {
  authorizationUrl: string;
};

export const Authorization = () => {
  const { translate } = useTranslation("pages.stores.create.amazonIntegration");
  const { getValues } = useFormContext();

  const { mutate, isLoading } = useCustomMutation<AuthorizationResponse>();

  const handleAuthorization = () => {
    mutate(
      {
        url: "authorization/start",
        method: "post",
        values: {
          marketplaceId: getValues("country").id,
        },
      },
      {
        onSuccess: (data) => {
          localStorage.setItem("storeName", getValues("name"));
          window.location.href =
            data.data.authorizationUrl +
            "&state=" +
            getValues("country").amazonID +
            "&redirect_uri=" +
            encodeURIComponent(window.location.href);
        },
      },
    );
  };

  return (
    <Container
      component={Card}
      sx={{
        padding: "24px",
        marginBottom: "16px",
      }}
    >
      <Typography variant="body1" fontWeight={"bold"}>
        {translate("title")}
      </Typography>
      <Alert
        icon={<InfoOutlined fontSize="inherit" />}
        severity="info"
        sx={{ marginTop: "16px" }}
      >
        <Typography variant="body2">{translate("info")}</Typography>
      </Alert>

      <Box sx={{ margin: "16px" }}>
        <Typography variant="body2">{translate("description")}</Typography>
        <Typography variant="body2">{translate("description2")}</Typography>
      </Box>

      <Box
        sx={{
          display: "flex",
          flexDirection: "row",
          justifyContent: "center",
          alignContent: "center",
          backgroundColor: "grey.100",
          borderRadius: "4px",
        }}
      >
        <img
          src={authHelperImage}
          alt={translate("imageAltText1")}
          style={{ width: "60%", objectFit: "contain", marginRight: "16px" }}
        />
        <AmazonSelectExample
          storeName={getValues("name")}
          selectedCountry={getValues("country").countryName}
        />
      </Box>

      <Box
        sx={{
          margin: "16px",
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
        }}
      >
        <Typography variant="body2">{translate("description3")}</Typography>
        <img
          src={authHelperImage2}
          alt={translate("imageAltText2")}
          style={{
            width: "60%",
            objectFit: "contain",
            margin: "32px 0",
            border: "1px solid #e0e0e0",
            borderRadius: "4px",
            padding: "16px",
          }}
        />
        <Typography variant="body2">{translate("description4")}</Typography>
        <LoadingButton
          loading={isLoading}
          variant="contained"
          color="primary"
          sx={{ marginTop: "32px" }}
          onClick={handleAuthorization}
        >
          {translate("button")}
        </LoadingButton>
      </Box>
    </Container>
  );
};
